import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "radio-group-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Wybierz rodzaj badania "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "radio-button form-radio-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_5 = { class: "radio-button form-radio-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}

import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { useField } from 'vee-validate';


export default {
  __name: 'CTType',
  setup(__props) {

const { value, errorMessage } = useField('ctType');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RadioGroup), {
      class: "radio-group radio-group--column",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_isRef(value) ? (value).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "contrast"
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
                name: "ctType",
                value: "contrast"
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_4,
              _createTextVNode(" Tomografia z kontrastem ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "no-contrast"
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null)),
                name: "ctType",
                value: "no-contrast"
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_6,
              _createTextVNode(" Tomografia bez kontrastu ")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}